module.exports = __webpack_public_path__ + "static/img/crown.3ac597fa.png";